
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"#fff"}},[_c('circle',{attrs:{"cx":"8","cy":"8","r":"8","stroke":"none"}}),_c('circle',{attrs:{"cx":"8","cy":"8","r":"7.5"}})]),_c('path',{attrs:{"d":"M6.752 9.975a3.483 3.483 0 01.2-1.3 2.665 2.665 0 01.722-.949 3.707 3.707 0 00.7-.76 1.2 1.2 0 00.174-.619q0-.982-.9-.982a.92.92 0 00-.688.264 1.042 1.042 0 00-.27.731H5.008a2.236 2.236 0 01.716-1.737 3.31 3.31 0 013.832-.032 2.117 2.117 0 01.679 1.682 2.041 2.041 0 01-.22.931 3.826 3.826 0 01-.771.973l-.47.447a1.59 1.59 0 00-.5.993l-.023.354zm-.168 1.778a.844.844 0 01.264-.639 1.034 1.034 0 011.352 0 .9.9 0 01.005 1.269 1.058 1.058 0 01-1.363 0 .837.837 0 01-.258-.63z","fill":"#fff"}})])
          )
        }
      }
    